/* Carrito flotante móvil - sticky-cart.js */
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 749) {
    const buyButton = document.querySelector('.product-form__buttons .button--full-width');
    if (!buyButton) return;

    const sticky = document.createElement('button');
    sticky.textContent = 'Agregar al carrito';
    sticky.style.cssText = [
      'position:fixed',
      'bottom:1rem',
      'left:1rem',
      'right:1rem',
      'width:calc(100% - 2rem)',
      'z-index:9999',
      'display:none',
      'background-color:#000',
      'color:#fff',
      'border:none',
      'border-radius:4px',
      'font-size:15px',
      'font-family:inherit',
      'padding:16px',
      'cursor:pointer',
      'box-sizing:border-box'
    ].join(';');

    document.body.appendChild(sticky);

    sticky.addEventListener('click', function() {
      buyButton.click();
    });

    function checkVisibility() {
      const rect = buyButton.getBoundingClientRect();
      // Mostrar sticky solo cuando el botón original está AÚN por debajo de la pantalla
      sticky.style.display = rect.top > window.innerHeight ? 'block' : 'none';
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    checkVisibility();
  }
});